import React from 'react';

import { Spacer, SpacerSize } from '@bytel/trilogy-react';

interface ResponsiveSpacerProps {
    desktopSize: SpacerSize;
    mobileSize: SpacerSize;
}

export function ResponsiveSpacer({ desktopSize, mobileSize }: ResponsiveSpacerProps) {
    return (
        <>
            <Spacer size={desktopSize} className='is-hidden-mobile' />
            <Spacer size={mobileSize} className='is-hidden-tablet' />
        </>
    );
}
